import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Label } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import Card from '../../common/components/Card';

class FormsList extends Component {

    mapStatusStyle(status) {
        let color = '';
        let icon = '';

        switch (status) {
            case 'New':
                color = 'danger';
                icon = 'times';
                break;
            case 'Draft':
                color = 'warning';
                icon = 'edit';
                break;
            case 'Final':
                color = 'success';
                icon = 'check';
                break;
        }

        return { color, icon };
    }

    render() {
        const { t, paymentId, forms } = this.props;

        return (<div>
            {forms && forms.length > 0 && <div>
                <div style={{ marginBottom: 10 }}>{t('FO_IndividualConsultation_Forms')}</div>
                <Row>
                    {forms.map(form => {
                        const { color, icon } = this.mapStatusStyle(form.status);
                        return <Col sm={12}>
                            <Link to={`/individual-consultation/${paymentId}/forms/${form.id}`} style={{ textDecoration: 'none' }} key={form.id}>
                                <Card style={{ marginBottom: 20 }}>
                                    <Label className='pull-right' bsStyle={color} style={{ lineHeight: 1.5 }}>
                                        <FontAwesome name={icon} /> {t(`FormStatus_${form.status}`)}
                                    </Label>
                                    <h4 style={{color: '#2E5BFF'}}>
                                        <FontAwesome name={'play'} style={{ marginRight: 5, lineHeight: 1.5 }} />{t(`AssessmentForm_Consultation_${form.name}`)}
                                    </h4>
                                    <div className='text-muted'>
                                        {t('FO_IndividualConsultationForm_Modified')} <b style={{ color: '#1c9979' }}>{moment(form.modified).format('lll')}</b>
                                    </div>
                                </Card>
                            </Link>
                        </Col>;
                    })}
                </Row>
            </div>}
        </div>);
    }
}

FormsList.propTypes = {
    forms: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
    }))
};

export default withTranslation()(FormsList);